import React from 'react'
import * as THREE from "three"
import { useFBO } from '@react-three/drei';
import { useFrame } from '@react-three/fiber';
import { useSelector } from 'react-redux';

// Crea la mesh della porta del laterale Cristal
export default function KitPortaCristal({altezzaPorta, position, rotationCylinder}) {
    const altezzaPedana = useSelector(state => state.uiPedanaMenu.realAltezza); 

    const buffer = useFBO()
    useFrame((state) => {
        state.gl.setRenderTarget(buffer)
        state.gl.render(state.scene, state.camera)
        state.gl.setRenderTarget(null)
    })     

    return(
    <>          
        <mesh position={[position[0], altezzaPorta + altezzaPedana*1, position[2]]} rotation={rotationCylinder}>
            <cylinderGeometry args={[0.075, 0.075, 1, 16]} />
            <meshPhongMaterial emissive={"#111111"} opacity={0.7} transparent side={THREE.DoubleSide}/>            
        </mesh>   
    </>  
    )
}
